import { render, staticRenderFns } from "./ShweDetailMain.vue?vue&type=template&id=95790c78&scoped=true&"
import script from "./ShweDetailMain.vue?vue&type=script&lang=js&"
export * from "./ShweDetailMain.vue?vue&type=script&lang=js&"
import style0 from "./ShweDetailMain.vue?vue&type=style&index=0&id=95790c78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95790c78",
  null
  
)

export default component.exports